"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_accelerometer_dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "0731c3cd-71ba-4ce7-861e-822ff0a74871",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c9d5d049-d510-4435-a91c-744a08fea9c1",
    x1: 112.74,
    y1: -480.36,
    x2: 169.77,
    y2: -537.38,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -402)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "accelerometer-hi"), /*#__PURE__*/React.createElement("g", {
    id: "6cb69ea2-f55c-4419-aaca-db6ca3ac201f",
    "data-name": "ca239d33-7af1-4ee7-a7e7-de04e9c627ed"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4221f972-6c14-4b6e-aa3b-ca85d9cf3c15",
    "data-name": "297c8bce-ad82-43ca-81ff-dc494588329b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a0ce2fd7-c8c1-45e6-95d4-f1f5318c7bc7",
    "data-name": "79dd82aa-7f90-4b0a-827d-e4387f151ea4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4b9e1ce4-3e5b-4703-a95b-0e216b4d1a20",
    "data-name": "bb5ca9ea-786d-43b6-a968-268cce7fb1eb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e17cc3d1-1e3d-4675-bbe8-cebb12390563",
    "data-name": "c6008d96-1265-4725-93d1-3c0adec4b000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d727ba5f-c252-448c-b4c4-2fb8ddd531f9",
    "data-name": "2515ffe6-9028-481d-b256-64db129ec49f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9d1435a9-928d-481c-9858-156d142dda4e",
    "data-name": "26236544-dd18-4a0c-a21b-740a4424c4e5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "45d71982-6b6a-4636-a190-f91916056e6d",
    "data-name": "81b69423-8804-4744-8234-3a0f44cce909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "56af594c-07fa-4e86-b764-c2f2633ed5ec",
    "data-name": "f1361f1b-d81b-4da1-95ad-76b42dbb15be"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f7c23a1d-e27a-4d0e-b1d3-8fd005460bfd",
    "data-name": "cc6278a2-8699-4ec2-ad50-7e57af75c84b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "44ce44ed-aede-40c5-ad20-6b198a6abdd7",
    "data-name": "8511fd9c-dace-497f-a988-09d1dd4a4819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "627d21e2-e448-4255-8150-231a690e21f9",
    "data-name": "4fcde42a-d653-4958-bc95-8719af0841b4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7788b1a3-9fab-417a-9335-1b15083742a8",
    "data-name": "2d583a03-c55c-4dbf-a46b-ae0ba7424903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7f19c168-5216-498c-b3c6-467d0c1d4d09",
    "data-name": "9fb3d8a4-b20e-4547-a73f-25fbd0533359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "08110cd7-445c-4209-b905-8ed1a461aaeb",
    "data-name": "d2bb4838-d886-4598-a407-dd42cdf47bb1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a06c14c7-2376-4051-8169-2a9baa6e216f",
    "data-name": "11f0804a-efde-4c6e-bb2f-63b584a12512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8961307f-4f9e-4aea-9b8d-748e7c4c336a",
    "data-name": "784de820-2b32-4ffd-b69a-4bbc94493093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dc7f867e-418c-4927-857a-a93e23b2de0d",
    "data-name": "033269b2-ddf2-4470-ab4c-245745df9ea3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "45e0ed42-84a5-4aa7-88e7-fbd090405997",
    "data-name": "1937cd4b-d9f3-47af-88dd-5b06fbbcb5de"
  }, /*#__PURE__*/React.createElement("g", {
    id: "464595c7-81a1-493a-b255-31aa7a2b3239",
    "data-name": "2084fda6-a716-4487-942d-47c79bd05af8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9aacfd50-2400-49a9-8da5-da3d4608bb16",
    "data-name": "7d335c61-5e7a-4d0c-a0d6-f5891cff728b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5b883971-5f34-4772-96c9-614233bcc1a2",
    "data-name": "598e6789-3709-41d8-9a10-07f5715b9d1f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8c2b3188-bf99-4652-8383-865a3a4d0a5c",
    "data-name": "4fc924e3-d55d-4fb6-9499-d87ac1454753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4e31a5a0-3e7e-4fc5-b960-3919cb7fe5df",
    "data-name": "78fed9a9-4a45-43d8-ac06-4a64e04304b0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "66e894a7-f75e-4b06-9327-357255c6561a",
    "data-name": "13dcfa48-5dc0-4a40-abcd-7d138b06ae27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "08b073b8-a1d9-4d8b-9151-e1f0241dd297",
    "data-name": "9a84c816-de68-409f-9930-9e2bd813aa0f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4be4e9e5-2835-4f1d-8c3a-287a37cc6198",
    "data-name": "eb832ee7-5ca1-4d21-8838-13d64d694f4e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01091bc0-d09c-45d5-8b6b-db3858e65539",
    "data-name": "0c14d960-2e23-4e76-b754-7b2c07c2a23a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 80,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174A80,80,0,0,1,16,95v1a80,80,0,0,0,160,0V95A80,80,0,0,1,96,174Z",
    transform: "translate(0 0)",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "0ac9f616-cc1b-4a98-8e84-00f4d2ae767c",
    "data-name": "4490ee3a-b20d-472c-a8ce-2f58853a945b",
    x1: 96,
    y1: 35.54,
    x2: 96,
    y2: 52.54,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "15a22b9a-6c91-4660-8f61-9c4b78a1e8b1",
    "data-name": "1bb5c6ec-33b5-404f-8d2c-b070adae7c3f",
    x1: 52.37,
    y1: 96,
    x2: 35.37,
    y2: 96,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "fcd99352-6331-4dcd-bc01-2ac7b5441fc5",
    "data-name": "640b71d9-4284-4eac-8426-791e233d1b40",
    x1: 139.37,
    y1: 95.98,
    x2: 156.37,
    y2: 95.98,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "0f5e8bf4-e389-45d3-bc62-465f9f9f83a5",
    "data-name": "65238655-3ebb-4b80-91fb-13dc833570fe",
    x1: 65.11,
    y1: 65.28,
    x2: 53.09,
    y2: 53.26,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1,104,144,160a79.89,79.89,0,0,0,32-64c0-2-.1-4-.24-5.91l-37.38-37Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#c9d5d049-d510-4435-a91c-744a08fea9c1)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 12,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("line", {
    id: "80f3c617-78ab-43ba-9d74-4c1cca2ac282",
    "data-name": "d4903cc5-ada7-49b4-9d46-f8d633173db6",
    x1: 104.73,
    y1: 87.77,
    x2: 136,
    y2: 56.5,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,57.48,107.71,88.75a4.4,4.4,0,0,1-.67.54,12.07,12.07,0,0,1,.53,1.57l.14-.11L139,59.48a4.18,4.18,0,0,0,1.1-4A4.08,4.08,0,0,1,139,57.48Z",
    transform: "translate(0 0)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,106a12,12,0,0,1-12-11c0,.33,0,.66,0,1a12,12,0,0,0,24,0,6.7,6.7,0,0,0,0-1A12,12,0,0,1,96,106Z",
    transform: "translate(0 0)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))))))))))))))))))))))))))))));
}

var _default = ic_accelerometer_dark;
exports.default = _default;